import Worker from "worker-loader!./UploadWorker.js";
import * as Comlink from "comlink";

const worker = Comlink.wrap(new Worker());

export const parseGeoJson = worker.parseGeoJson;
export const processShapefile = worker.processShapefile;
export const getSelectedCharacterLength = worker.getSelectedCharacterLength;
export const getSelectedVerticesCount = worker.getSelectedVerticesCount;
